import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, ViewEncapsulation, Injector, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, Label, LabelType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'tag-picker',
    templateUrl: './tag.picker.component.html',
    styleUrls: ['./tag.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TagPickerComponent),
            multi: true
        }
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        PickerItemModule,
    ]
})
export class TagPickerComponent extends PickerBaseComponent implements OnChanges {

    @Input() public data: Label[];
    @Input() public placeholder = '<Tag>';
    @Input() public type: LabelType = null;
    @Input() public multiple = false;
    @Input() public appendTo;

    public data$: Observable<Label[]>;
    public PickerItemStyle = PickerItemStyle;

    constructor(
        cdr: ChangeDetectorRef,
        injector: Injector,
        private http: HttpClient
    ) {
        super(injector);
    }

    public ngOnChanges() {

        this.data$ = this.fetch === PickerFetch.Automatic
            ? this.getLabels()
            : of(this.data);

    }

    private getLabels(): Observable<Label[]> {
        return this.http.get<Label[]>(`/api/label/tag/${this.type}`);
    }


    public compareFn(data1: Entity, data2: Entity): Boolean {
        // data will included category & subcategory
        if (!data1?._id || !data2?._id) {
            return false;
        }

        const same = data1?._id === data2?._id;
        return same;
    }
}

@NgModule({
    imports: [
        TagPickerComponent
    ],
    declarations: [],
    providers: [],
    exports: [
        TagPickerComponent
    ],
})
export class TagPickerModule { }
